import React from 'react'
import { ThemeProvider } from '@mui/material/styles';
import { ServerStyleSheets } from '@mui/styles';
import createEmotionServer from '@emotion/server/create-instance';
import { CacheProvider } from '@emotion/react';
import ReactDOMServer from 'react-dom/server'
import { WidgetInitializationParameters } from 'widgets-shared/core'
import createEmotionCache from 'smartstream-widgets/utils/createCache';
import MainLinesWidget from './MainLines'

export function ssrReactFunction(theme: {
  [K in string]: string
}, props: WidgetInitializationParameters) {
  const sheets = new ServerStyleSheets()
  const cache = createEmotionCache();
  const emotionServer = createEmotionServer(cache)
  const Widget = MainLinesWidget(props)

  const html = ReactDOMServer.renderToString(
    sheets.collect(
      <CacheProvider value={cache}>
        <ThemeProvider theme={theme}>
          <Widget />
        </ThemeProvider>
      </CacheProvider>
    )
  )
  const { css: emotionCss } = emotionServer.extractCritical(html)
  const css = sheets.toString()

  return {
    html,
    css: emotionCss + css
  }
}
export default MainLinesWidget